import React, { Component } from "react";
import ReactTable from "react-table";
import { Button, Modal, Header, Loader, Icon, Popup, Segment } from "semantic-ui-react";
import matchSorter from 'match-sorter';
import _ from 'lodash';

import { formatCurrency } from "../../utils/constants";
import { AppContext } from "../../utils/context";
import request from "../../utils/request";

import Details from '../forms/winners/Details';
import AddPrize from "../../pages/Events/AddPrize";

class WinnersTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
        expanded: {},
        openRedrawModal: false,
        redrawInProgress: false,
        oldDrawId: null
    }
  }
  handleCancelRedraw = () => { // close manual cta redraw modal
    this.setState({ openRedrawModal: false });
  }
  handleOpenRedraw = () => { // open manual cta redraw modal
    this.setState({ openRedrawModal: true });
  }
  handleRedrawNumber = async (id) => { // redraw number for manual cta
    this.setState({ redrawInProgress: true });
    const results = await request.post(this, `api:/event/${this.props.eventId}/winners/redraw`, { draw_id: id }).then(resp => {
        this.setState({
            redrawInProgress: false,
            oldDrawId: id
        });
        this.props.fetchXhr(resp.success ? "success" : "error", resp.message)
    });

    this.handleCancelRedraw()
    return results;
  }
  render() {
    const { winners, event, init, isLoading, ctaCardType, manualCtaRedrawEnabled } = this.props;
    const { openRedrawModal, redrawInProgress } = this.state;
    const { config } = this.context;
    let columns = [
        {
            expander: true,
            Header: () => <strong>More</strong>,
            width: 65,
            Expander: ({ isExpanded, ...rest }) => (
            <div style={{ display: (rest.original.number === null || rest.original.prize_id > 0) ? "none" : "block" }}>
                {isExpanded ? (
                <Icon name="caret down" />
                ) : (
                    <Icon name="caret right" />
                )}
            </div>
            ),
            style: {
            cursor: "pointer",
            fontSize: 25,
            padding: "0",
            textAlign: "center",
            userSelect: "none"
            },
            filterable: false
        },
        {
            Header: "Draw Title",
            accessor: d => d.prize > 0 ? `${d.prize_prefix}${d.title}: ${formatCurrency(d.prize, config.language, 2)}` : d.prize_prefix + d.title,
            id: "title",
            filterMethod: (filter, rows) => matchSorter(rows, filter.value, { threshold: matchSorter.rankings.WORD_STARTS_WITH, keys: ["title"] }),
            filterAll: true
        },
        {
            Header: "Draw Time",
            accessor: d => d.draw_at,
            id: "draw_at",
            filterable: false
        },
        {
            Header: "Draw Status",
            accessor: d => (d.status === "queued" || d.status === "in_progress") ?
                <>
                    <Loader active inline='centered' size='mini' />{_.startCase(d.status)}
                    <Popup
                    basic
                    content={d.game_id === 3 && d.number && d.card?.suit === "" ? "Awaiting manual card selection" : "Draw in progress"}
                    size='mini'
                    trigger={<Icon name='info circle' color='blue' size='small' />}
                    />
                </> :
                _.startCase(d.status),
            id: "status",
            style: {textAlign: "center"},
            filterMethod: (filter, rows) =>
            matchSorter(rows, filter.value, { threshold: matchSorter.rankings.WORD_STARTS_WITH, keys: ["status"] }),
            filterAll: true
        },
        {
            Header: "Ticket #",
            accessor: "number",
            width: 225,
            filterMethod: (filter, rows) => matchSorter(rows, filter.value, { threshold: matchSorter.rankings.WORD_STARTS_WITH, keys: ["number"] }),
            filterAll: true
        },
        {
            Header: "Card",
            id: "card.id",
            accessor: d => (d.card === null || !d.card) ? "" : (
            <div>
                {d.card.suit === "D" ? (<span style={{ "color": "red" }}>&diams;</span>) : ""}
                {d.card.suit === "H" ? (<span style={{ "color": "red" }}>&hearts;</span>) : ""}
                {d.card.suit === "S" ? (<span>&spades;</span>) : ""}
                {d.card.suit === "C" ? (<span>&clubs;</span>) : ""}
                {d.card.suit === "RJ" ? (<span style={{ "color": "red" }}>&#x1F0DF; Red Joker</span>) : ""}
                {d.card.suit === "BJ" ? (<span>&#x1F0CF; Black Joker</span>) : ""}
                {d.card.suit === "" ? <Loader active inline='centered' size='mini' /> : " "}
                {d.card.suit !== "RJ" && d.card.suit !== "BJ" && d.card.rank}
            </div>
            ),
            filterable: false
        },
        {
            Header: "Envelope Opened",
            id: "card_opened",
            accessor: d => (d.card === null || !d.card) ?
                "N/A" : (<div>{d.card.envelope}</div>),
            filterable: false
        },
        {
            Header: "Action",
            id: "draw.id",
            accessor: d => d.is_secondary != 1 ?
            (ctaCardType === "physical" && manualCtaRedrawEnabled && d.game_id === 3 && d.status === "in_progress" ?
                <Modal
                    trigger={<Button
                        content="Redraw"
                        compact
                        primary
                        onClick={() => this.handleOpenRedraw()}
                        disabled={this.state.oldDrawId === d.id}
                        />}
                    open={openRedrawModal}
                    closeIcon
                    onClose={() => this.handleCancelRedraw()}
                    size="small"
                >
                    <Header content='Do you wish to Redraw?' />
                    <Modal.Content loading={redrawInProgress ? "true" : "false"}>
                        <Segment basic>
                            <Header as="h2" color="red">
                            NOTE: This action will archive the previous draw and pick a new winner!
                            </Header>
                        </Segment>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button primary content="Cancel" onClick={() => this.handleCancelRedraw()} />
                        <Button primary content="Confirm and Redraw" onClick={() => this.handleRedrawNumber(d.id)} />
                    </Modal.Actions>
                </Modal> : "") : (
            <div>
                <Modal
                    trigger={<Button icon="edit" primary />}
                    closeIcon
                    onClose={this.props.init}
                    size="small"
                >
                    <Header icon='suitcase' content='Edit Secondary Prize' />
                    <Modal.Content>
                        <AddPrize eventId={this.props.eventId} event={this.props.event} mode="edit" draw={d} fetchDraws={this.props.fetchDraws} />
                    </Modal.Content>
                </Modal>
                <Button
                    color="red"
                    type="button"
                    onClick={() => this.props.showConfirm(d.id, `Are you sure you want to delete ${d.title}?`)}
                    icon="trash"
                    disabled={d.number != null}
                />
            </div>
            ),
            width: 125,
            filterable: false
        }
    ];
    if (event.game_id !== 3) { // remove Card column for no cta events
        columns.map(col => {
            if (col.Header === "Card" || col.Header === "Envelope Opened") col.show = false;
        });
    }
    return (
      <ReactTable
        data={winners}
        columns={columns}
        className="-striped -highlight"
        loading={isLoading} // Display the loading overlay when we need it
        resizable={true}
        defaultPageSize={100}
        minRows={0}
        filterable
        expanded={this.state.expanded}
        onExpandedChange={(newExpanded, index, event) => {
            if (newExpanded[index[0]] === false) {
              newExpanded = {}
            } else {
              Object.keys(newExpanded).map(k => {
                newExpanded[k] = parseInt(k) === index[0] ? {} : false
              })
            }
            this.setState({ expanded: newExpanded });
        }}
        SubComponent={row => {
            if (row.original.number === null || row.original.prize_id > 0) return false;
            return (
                <div style={{ padding: "20px" }}>
                    <Details winner={row.original} init={init} />
                </div>
            );
        }}
      />
    );
  }
}

WinnersTable.contextType = AppContext;
export default WinnersTable;
